import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { PromotionBlock } from "../components/PromotionBlock";

type IProps = Immutable<templates.PromotionBlockTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    return <PromotionBlock value={props.value} />;
};
